import { Component, OnInit, Input, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { StateInteractionService } from 'angular-engine/engine/service/dynamic/state.interaction.service';
import { UtilService } from 'angular-engine/engine/service/util/util.service';
import { DataService } from "angular-engine/engine/service/data/api.data.service";
import { CoreEffects } from 'angular-engine/engine/state/effect/core.effects';
import { Rows } from '../../components/rows/rows.component';
import { StaticContainer } from 'angular-shared-features/feature/shared-component/static-container.component';

@Component({
  selector: 'series-container',
  templateUrl: './series-container.template.html',
  styleUrls: ['./series-container.style.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SeriesContainer extends StaticContainer {
  private getSeriesSlides(series) {
    let meta = series.meta || series;
    return [meta, meta.featured_item];
  }
}


// WEBPACK FOOTER //
// ./src/angular-framework-client-components/containers/series-container/series-container.component.ts